module.exports = __webpack_public_path__ + "static/media/_somaliland.01603e6c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/_somaliland.svg
// module id = 2352
// module chunks = 7